import { convertStatusTypeToObject } from 'commons/utils/convertStatusTypeToObject';
import { useUpdatePlanMutation } from '../billingPlansApi';

export function useUpdatePlan() {
  const [updatePlan, { status }] = useUpdatePlanMutation({
    fixedCacheKey: 'updatePlan',
  });

  return { updatePlan, status, ...convertStatusTypeToObject(status) };
}
